import * as React from 'react';
import SVGInline from 'react-svg-inline';

import Card, { CardProps } from './Card';
import DateComponent from '../../containers/Date/Date';

import styles from './Card.scss';
import { Tweet } from '../../GraphQL';

interface TwitterCardProps extends CardProps, Tweet {
  icon: string;
  className?: string;
}

const TwitterCard: React.SFC<TwitterCardProps> = ({
  author,
  postedAt,
  icon,
  bubble,
  className,
  body,
}) => (
  <Card className={`${styles.twitterCard} ${className}`} bubble={bubble}>
    <div className="d-flex py-3 px-4">
      <SVGInline svg={icon} className={styles.twitterIcon} />
      <div className={styles.content}>
        <div className={styles.text} dangerouslySetInnerHTML={{ __html: body }} />
        <div className={styles.footer}>
          <span className={styles.author}>{author}</span>
          <span className={styles.date}>
            <DateComponent value={new Date(postedAt * 1000)} />
          </span>
        </div>
      </div>
    </div>
  </Card>
);

export default TwitterCard;



// WEBPACK FOOTER //
// /www/client/src/components/Card/TwitterCard.tsx